<template>
  <div>
    <LoaderMaskComponent v-if="lyLoading"/>
    <div v-else>
      <breadcrumb-component
          :moduleTitle="'Service management'"
          :mainTitle="'Port forwarding'"
          :subTitle="'Port forwarding list'"
      />
      <div class="row">
        <div class="col-md-12">
          <div class="card card_full_window vm_list_page ">
            <div class="card-body">
              <div class="common_content_wrap">
                <div class="common_content_left">
                  <ServiceLeftMenuComponent/>
                </div>
                <div class="common_content_right">
                  <div v-if="hasPagePermission('Port forwarding')" class="vm_list_content">
                    <div class="d_flex_start pt_10 pb_10">
                      <div class="common_dropdown dropdown_no_radius mr_10" v-if="customer.selected_service_id == 1 || customer.selected_service_id == 2">
                        <div class="btn-group dropdown-center dropdown-fill-text">
                          <button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown"
                          aria-expanded="false">
                            <span v-if="selectedPlatform">{{ selectedPlatform.value }}</span>
                            <span v-else>All Platform</span>
                          </button>
                          <ul class="dropdown-menu no_arrow">
                            <button class="dropdown-item" type="button" @click.prevent="changePlatform(null)"><span>All Platform</span>
                            </button>
                            <li v-for="(serverPlatform, index) in serverPlatforms" :key="'server_platform_'+index"
                                @click.prevent="changePlatform(serverPlatform)">
                              <button class="dropdown-item" type="button"><span>{{ serverPlatform.value }}</span></button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="d_flex_start pt_10 pb_10">
                      <button
                          v-if="hasPermission('Create' || 'Update') && customer.selected_service_id && customer.selected_service_id != 1 && selectedService.id !== 4"
                          type="button" class="btn btn-outline-primary btn-sm mr_15 width_250p"
                          @click="openModal()"
                      >
                        Port Forwarding Create
                      </button>
                      <button
                          v-if="hasPermission('Delete')"
                          type="button"
                          class="btn btn-outline-danger btn-sm width_100p"
                          @click.prevent="deleteTheRecord()"
                          :disabled="!canDelete"
                      >
                        Delete
                      </button>
                      <button
                          type="button"
                          class="btn btn-outline-primary btn-sm ml_15 width_100p"
                          @click.prevent="loadData()"
                      >
                        Refresh
                      </button>
                    </div>
                    <cloud-table-component
                        :columns="columns"
                        :rows="portForwardings"
                        :sortable="sortable"
                        :pagination="pagination"
                        @sorting="sorting"
                        @pageChanged="pageChanged">

                        <template v-slot:kt_platform="{ row }">
                          <span v-if="row.kt_platform == 'g'" class="color_success text-center">G</span>
                          <span v-if="row.kt_platform == 'd'" class="color_warning text-center">D</span>
                        </template>

                        <template v-slot:kt_job_status="{ row }">
                          <span v-if="row.kt_job_status == 'pending'" class="color_warning">Pending</span>
                          <span v-if="row.kt_job_status == 'completed'" class="color_success">Completed</span>
                          <span v-if="row.kt_job_status == 'failed'" class="color_danger">Failed</span>
                        </template>

                      <template v-slot:id="{ row }">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" :id="'action_'+row.id"
                                 @focus="checkSinglePortForwarding(row, $event)"
                                 :checked="selectedPortForwarding?.id === row.id">
                          <label class="form-check-label" :for="'action_'+row.id"></label>
                        </div>
                      </template>

                    </cloud-table-component>
                  </div>
                  <div v-else>
                    <p>You do not have permission to view this content.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BaseModal
          v-if="isShowContactModal"
          title="Add port forwarding"
          :closeModal="closeModal"
      >
        <PortForwardingForm
            :closeModal="closeModal"
            :loadData="loadData"
            :editId="editId"
        />
      </BaseModal>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
import ServiceLeftMenuComponent from "../ServiceLeftMenuComponent.vue";
import CloudTableComponent from '@/components/shared/CloudTableComponent.vue';
import BreadcrumbComponent from '@/components/shared/BreadcrumbComponent.vue';
import BaseModal from "@/components/BaseModal.vue";
import PortForwardingForm from "./PortForwardingForm";
import {checkPermission} from "@/mixins/permissionsHelper";
import {echo} from "@/services/echo";

export default {
  name: 'port-forwardings',
  components: {
    LoaderMaskComponent,
    ServiceLeftMenuComponent,
    CloudTableComponent,
    BreadcrumbComponent,
    BaseModal,
    PortForwardingForm,
  },
  data() {
    return {
      lyLoading: false,
      selectedPlatform: null,
      portForwardings: [],
      filter: {
        kt_platform: '',
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'cloudServer.server_name,cloudNetwork.public_ip,private_port_one,private_port_two,public_port_one,public_port_two,protocol',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      },
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: "",
          field: "id",
          sortable: false,
          slot: true,
        },
        {
          label: "Server",
          field: "cloudServer.server_name",
          sortable: true,
        },
        {
          label: "Public IP",
          field: "cloudNetwork.public_ip",
          sortable: true,
        },
        {
          label: "Kt platform",
          field: "kt_platform",
          sortable: true,
          slot: true,
        },
        {
          label: "Status",
          field: "kt_job_status",
          sortable: true,
          slot: true
        },
        {
          label: "Private port one",
          field: "private_port_one",
          sortable: true,
        },
        {
          label: "Private port two",
          field: "private_port_two",
          sortable: true,
        },
        {
          label: "Public port one",
          field: "public_port_one",
          sortable: true,
        },
        {
          label: "Public port two",
          field: "public_port_two",
          sortable: true,
        },
        {
          label: "Protocol",
          field: "protocol",
          sortable: true,
        },
        {
          label: "Created at",
          field: "created_at",
          sortable: true,
        }
      ],
      update: {
        kt_platform: '',
      },
      pagination: null,
      selectedPortForwarding: null,
      isShowContactModal: false,
      editId: null,
      selectedService: null,
    }
  },
  computed: {
    ...mapGetters({
      customer: 'auth/getUserInfo',
      permissions: 'serverPermissions/getServicePermission',
      services: 'auth/getCustomerServices',
    }),
    canDelete() {
      return !!(this.selectedPortForwarding && this.selectedPortForwarding.kt_job_type === null);
    },
    serverPlatforms(){
      if(this.customer.g_platform && this.customer.d_platform){
        return [
          {label: 'g', value: 'G'},
          {label: 'd', value: 'D'},
        ];
      }else if(this.customer.g_platform){
        return [
          {label: 'g', value: 'G'},
        ];
      }else if(this.customer.d_platform){
        return [
          {label: 'd', value: 'D'},
        ];
      }else{
        return [
          {label: 'g', value: 'G'},
        ];
      }
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == from.name && !window._.isEqual(to, from)) {
        this.setQueryData(this.getAllQueryParams())
        this.loadData()
      }
    },
    customer: {
      handler(newVal, oldVal) {
        if (newVal?.selected_service_id !== oldVal?.selected_service_id) {
          // Perform actions when selected_service_id changes
          const newService = this.services.find((item) => item.id === parseInt(newVal?.selected_service_id));
          if (newService) {
            this.selectedService = newService
          } else {
            console.log('No matching service found');
          }
        }
        this.loadData();
      },
      deep: true, // Watch for changes in nested properties
      immediate: true, // Optional: Run the watcher immediately on component creation
    },
  },
  created() {
    const query = this.getAllQueryParams()
    if (query.page) {
      this.setQueryData(query)
    }
    this.loadData();
  },
  mounted() {
    if(this.$route.query.kt_platform){
      let platform = this.serverPlatforms.filter(item => item.label == this.$route.query.kt_platform)
      if(platform && platform.length > 0){
        this.selectedPlatform = platform[0]
      }
    }
    this.portForwardingSocketInit()
  },
  beforeUnmount() {
    echo.leaveChannel(`kt_cloud_firewall_records.${this.customer.id}`);
  },
  methods: {
    portForwardingSocketInit(){
      echo.channel(`kt_cloud_port_forwarding_records.${this.customer.id}`)
          .listen('.kt_cloud_port_forwarding_records.updated', () => {
            this.loadData();
            // if (event.deleted_at) {
            //   const index = this.portForwardings.findIndex(r => r.id === event.id);
            //   if (index !== -1) {
            //     this.portForwardings.splice(index, 1);
            //   }
            // } else {
            //   const index = this.portForwardings.findIndex(r => r.id === event.id);
            //   if (index !== -1) {
            //     this.portForwardings[index] = { ...this.portForwardings[index], ...event };
            //   }
            // }
          });
    },
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {
        kt_platform: query.kt_platform,
      }

      this.sortable = {
        order: query.sort,
        sort: query.sort_order
      }
    },
    resetAll() {
      this.sortable = {
        order: 'created_at',
        sort: 'desc'
      }

      this.filter = {
        kt_platform: '',
      }

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'cloudServer.server_name,cloudNetwork.public_ip,private_port_one,private_port_two,public_port_one,public_port_two,protocol',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute()
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    changePlatform(platform) {
      if (platform) {
        this.selectedPlatform = platform
      } else {
        this.selectedPlatform = ''
      }

      this.queryParams.page = 1;
      this.filter.kt_platform = this.selectedPlatform ? this.selectedPlatform.label : '';
      this.changeRoute()
    },
    loadData() {
      this.lyLoading = true
      this.axios.get('/port-forwardings', {
        params: {...this.queryParams, ...this.filter}
      }).then((response) => {
        this.portForwardings = response.data.data;
        this.pagination = response.data.meta;
      }).finally(() => {
        this.lyLoading = false;
      })
    },
    checkSinglePortForwarding(server, event) {
      event.target.blur();
      if (this.selectedPortForwarding?.id === server.id) {
        this.selectedPortForwarding = null;
      } else {
        this.selectedPortForwarding = server;
      }
    },
    deleteTheRecord(){
      if (this.selectedPortForwarding.cloud_service_id === 4){
        this.deleteProxmoxRecord()
      } else {
        this.deleteRecord()
      }
    },
    deleteRecord() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/port-forwardings/' + this.selectedPortForwarding.id)
              .then((response) => {
                if (response.data.success) {
                  this.selectedPortForwarding = null;
                  this.showSuccessMsg(response.data.message);
                  this.loadData();
                } else {
                  this.$swal({
                    text: response.data.message,
                    showCancelButton: false,
                    confirmButtonText: 'Close!',
                    confirmButtonColor: '#dd4b39',
                    reverseButtons: true
                  })
                }
              });
        }
      });
    },
    deleteProxmoxRecord() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/proxmox/destroy-port-forwarding/' + this.selectedPortForwarding.id)
              .then((response) => {
                if (response.data.success) {
                  this.selectedPortForwarding = null;
                  this.showSuccessMsg(response.data.message);
                  this.loadData();
                } else {
                  this.$swal({
                    text: response.data.message,
                    showCancelButton: false,
                    confirmButtonText: 'Close!',
                    confirmButtonColor: '#dd4b39',
                    reverseButtons: true
                  })
                }
              });
        }
      });
    },
    openModal(editId = null) {
      this.editId = editId
      this.isShowContactModal = true;
    },
    closeModal() {
      this.isShowContactModal = false;
    },
    hasPermission(action) {
      let portIndex = this.permissions?.cloud_sub_service?.indexOf('Port forwarding')
      let entity = this.permissions?.cloud_sub_service[portIndex];

      return checkPermission(this.permissions, entity, action);
    },
    hasPagePermission(entityName) {
      return this.permissions?.cloud_sub_service?.includes(entityName) || this.permissions?.cloud_sub_service?.includes('All');
    },
  }
}
</script>